export interface UnitGroup {
  label: string;
  units: readonly string[];
}

export const NUMERIC_UNIT_GROUPS: readonly UnitGroup[] = [
  { label: "Massa", units: ["g", "kg", "t"] },
  { label: "Volume", units: ["mL", "L", "m³"] },
  { label: "Temperatura", units: ["°C", "°F", "K"] },
  { label: "Pressão", units: ["bar", "psi", "Pa", "kPa"] },
  { label: "Velocidade", units: ["rpm", "m/s", "km/h"] },
  { label: "Comprimento", units: ["mm", "cm", "m"] },
  { label: "Vazão", units: ["L/min", "m³/h"] },
  { label: "Energia", units: ["J", "kJ", "kWh"] },
  { label: "Potência", units: ["W", "kW"] },
] as const;

// Spec 081 (FR-025) — o contador deixou de contar só peça. Uma linha que produz em quilo mede em
// quilo, e uma que envasa mede em litro: sem massa e volume aqui, essa linha não conseguia se
// configurar. A contagem vem primeiro porque continua sendo o caso comum.
export const COUNTER_UNIT_GROUPS: readonly UnitGroup[] = [
  { label: "Contagem", units: ["unidades", "peças", "ciclos", "caixas", "pacotes"] },
  { label: "Massa", units: ["g", "kg", "t"] },
  { label: "Volume", units: ["mL", "L", "m³"] },
] as const;

export const DURATION_UNIT_GROUPS: readonly UnitGroup[] = [
  { label: "Duração", units: ["s", "min", "h"] },
] as const;

export const ALL_NUMERIC_UNITS: readonly string[] = NUMERIC_UNIT_GROUPS.flatMap((g) => g.units);
export const ALL_COUNTER_UNITS: readonly string[] = COUNTER_UNIT_GROUPS.flatMap((g) => g.units);
export const ALL_DURATION_UNITS: readonly string[] = DURATION_UNIT_GROUPS.flatMap((g) => g.units);

export function isCanonicalUnit(
  category: "NUMERIC" | "COUNTER" | "DURATION",
  value: string
): boolean {
  const list =
    category === "NUMERIC"
      ? ALL_NUMERIC_UNITS
      : category === "COUNTER"
        ? ALL_COUNTER_UNITS
        : ALL_DURATION_UNITS;
  return list.includes(value);
}

export function unitGroupsFor(category: "NUMERIC" | "COUNTER" | "DURATION"): readonly UnitGroup[] {
  if (category === "NUMERIC") return NUMERIC_UNIT_GROUPS;
  if (category === "COUNTER") return COUNTER_UNIT_GROUPS;
  return DURATION_UNIT_GROUPS;
}
